import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import {
  NgbActiveModal,
  NgbDateParserFormatter,
  NgbDateStruct,
  NgbModal,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import { ModalTemplateComponent } from '../modal-template/modal-template.component';
import { ESEService } from '../ese.service';

@Component({
  selector: 'cygov-emerging-security-event-action-buttons',
  templateUrl: './emerging-security-event-action-buttons.component.html',
  styleUrls: ['./emerging-security-event-action-buttons.component.scss'],
  standalone: false,
})
export class EmergingSecurityEventActionButtonsComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @Input() isFromVendorListing: boolean = false;
  @Input() isCreateFromTemplate: boolean = false;
  @Input() isEditMode: boolean = false;
  @Output() upload = new EventEmitter<any>();
  @Output() download = new EventEmitter<any>();
  @Output() save = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() enableEdit = new EventEmitter<any>();
  @Output() addQuestion = new EventEmitter<any>();
  @Input() questions: any = [];
  @Input() disableDelete: boolean = true;
  @Output() saveButtonClicked = new EventEmitter<void>();
  previousSelectedDate: { day: number; month: number; year: number } | null = null;

  closeModalInstance: any;
  ngbModalOptionsUploadTemplate: NgbModalOptions = {
    size: 'sm',
    windowClass: 'modal-template-cont confirmation-filter-popup-window ese-template-questionnaire-uplaod-modal-window',
    backdropClass:
      'modal-template-cont-backdrop risk-popup-backdrop-modal ese-template-questionnaire-uplaod-modal-backdrop',
    backdrop: 'static',
    centered: true,
  };
  isShowDueDateCalendar: boolean = false;
  selectedDueDate: NgbDateStruct;
  eventDueDate: string;
  tomorrowDate: NgbDateStruct;
  eventName: any = '';

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    public parserFormatter: NgbDateParserFormatter,
    private eseService: ESEService
  ) {}

  ngOnInit() {
    const today = new Date();
    const tomorrow = new Date(today); // Create a new Date object based on today
    tomorrow.setDate(today.getDate()); // Set the date to tomorrow

    this.selectedDueDate = {
      day: tomorrow.getDate(),
      month: tomorrow.getMonth() + 1, // Months are 0-based, so add 1
      year: tomorrow.getFullYear(),
    };

    this.tomorrowDate = {
      day: tomorrow.getDate(),
      month: tomorrow.getMonth() + 1,
      year: tomorrow.getFullYear(),
    };
  }

  eventNameChanged(event: Event) {
    this.eventName = event.target as HTMLInputElement;
    this.eseService.eventName = this.eventName.value;
  }
  onUploadClick(): void {
    this.closeModal();
    this.fileInput.nativeElement.click();
  }
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (file) {
      this.upload.emit(file); // emit file to parent or handle as needed
    }
    this.closeModal();
    input.value = '';
  }
  openESETemplateModal(header: TemplateRef<any>, content: TemplateRef<any>, footer: TemplateRef<any>) {
    const modalRef = this.modalService.open(ModalTemplateComponent, this.ngbModalOptionsUploadTemplate);
    const compInstance = modalRef.componentInstance;

    this.closeModalInstance = modalRef;

    compInstance.customizeHeader = true;
    compInstance.headerContentRef = header;
    compInstance.contentRef = content;
    compInstance.footerContentRef = footer;
  }
  closeModal() {
    if (this.closeModalInstance) {
      this.closeModalInstance.close();
    }
  }
  selectedDueDateChangeFunc(event: { day: number; month: number; year: number }): void {
    if (
      this.previousSelectedDate &&
      this.previousSelectedDate.day === event.day &&
      this.previousSelectedDate.month === event.month &&
      this.previousSelectedDate.year === event.year
    ) {
      return;
    }
    this.selectedDueDate = event;
    this.previousSelectedDate = { ...event };
    const dDate = new Date(event.year, event.month - 1, event.day);
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    };
    this.eventDueDate = dDate.toLocaleDateString('en-US', options);
    this.eseService.dueDate = dDate.getTime();
    this.isShowDueDateCalendar = false;
  }
}
